import { render, staticRenderFns } from "./PlantCards.vue?vue&type=template&id=90c7a182"
import script from "./PlantCards.vue?vue&type=script&lang=js"
export * from "./PlantCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports